import FormLabel from "../../Common/FormLabel"
import { setInput, updateState, getOptions } from "../../utils/utils"
import style from "../../../../styles/Participant-GPRA.module.css"
import FormError from "../../Common/FormError"
const AdditionalQuestion = ({
  question,
  entity,
  errors,
  setEntity,
  removeError,
  disabled,
  number,
  alignment,
}) => {
  return (
    <div key={question.id} className={alignment === 0 ? "" : style.formRow}>
      {number === 0 ? (
        <FormLabel label={`${question?.title}`} required={question?.required} />
      ) : (
        <FormLabel label={`${number}. ${question?.title}`} required={question?.required}/>
      )}
      {setInput(
        question.type,
        entity["additional"]?.find(
          (v) => v.additionalQuestionId === question.id
        )?.answer,
        updateState,
        question.title,
        getOptions(question.options),
        errors[question.title],
        question.id,
        entity,
        setEntity,
        removeError,
        disabled,
        alignment,
        question?.defaultZero
      )}
      <FormError error={errors[question.title]} />
    </div>
  )
}
export default AdditionalQuestion
